import React from "react";
import JobsLogin from "./JobsLogin";

const JobsAuth = () => {
  return <JobsLogin />;
};

export default JobsAuth;
